/* Rapid Sport — runtime dominant-colour sampling for collection tiles.
   Reads the product image, finds its dominant chromatic colour, and writes
   --rs-tint-a / --rs-tint-b onto the tile so the background matches the product.
   Results cache in sessionStorage so repeat views are instant. */
(function () {
  var CACHE = 'rs-tint-v1';
  var store = {};
  try { store = JSON.parse(sessionStorage.getItem(CACHE) || '{}'); } catch (e) {}

  function save() {
    try { sessionStorage.setItem(CACHE, JSON.stringify(store)); } catch (e) {}
  }

  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h = 0, s = 0, l = (max + min) / 2, d = max - min;
    if (d) {
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = ((g - b) / d + (g < b ? 6 : 0));
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return [h, s, l];
  }

  function hsl(h, s, l) {
    return 'hsl(' + Math.round(h) + ' ' + Math.round(s * 100) + '% ' + Math.round(l * 100) + '%)';
  }

  /* Pick the most-represented chromatic colour, ignoring background white,
     near-black outlines and fully transparent pixels. */
  function sample(img) {
    var N = 48;
    var c = document.createElement('canvas');
    c.width = N; c.height = N;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, N, N);
    var d = ctx.getImageData(0, 0, N, N).data;

    var bins = {}, best = null, bestScore = -1;
    for (var i = 0; i < d.length; i += 4) {
      var a = d[i + 3];
      if (a < 200) continue;
      var r = d[i], g = d[i + 1], b = d[i + 2];
      var c3 = rgbToHsl(r, g, b);
      var S = c3[1], L = c3[2];
      if (L > 0.94 || L < 0.06) continue;          // paper white / pure black
      if (S < 0.08 && L > 0.82) continue;           // washed-out background
      var key = (r >> 4) + '-' + (g >> 4) + '-' + (b >> 4);
      var bin = bins[key] || (bins[key] = { n: 0, r: 0, g: 0, b: 0, s: 0, l: 0 });
      bin.n++; bin.r += r; bin.g += g; bin.b += b; bin.s += S; bin.l += L;
    }
    for (var k in bins) {
      var v = bins[k];
      var sat = v.s / v.n;
      // favour frequency, but weight saturated colours so brand colour beats grey
      var score = v.n * (0.45 + sat);
      if (score > bestScore) { bestScore = score; best = v; }
    }
    if (!best) return null;

    var h3 = rgbToHsl(best.r / best.n, best.g / best.n, best.b / best.n);
    var H = h3[0], S2 = h3[1], L2 = h3[2];

    // Keep tiles readable: clamp into a mid-dark, reasonably saturated band.
    S2 = Math.min(0.72, Math.max(0.18, S2));
    var lightL = Math.min(0.58, Math.max(0.40, L2));
    var darkL = Math.max(0.16, lightL - 0.22);
    return [hsl(H, S2, lightL), hsl(H, Math.min(0.85, S2 + 0.06), darkL)];
  }

  function paint(tile, pair) {
    tile.style.setProperty('--rs-tint-a', pair[0]);
    tile.style.setProperty('--rs-tint-b', pair[1]);
  }

  function run(tile) {
    if (tile.dataset.rsTinted) return;
    var img = tile.querySelector('img');
    if (!img || !img.currentSrc && !img.src) return;
    var key = (img.currentSrc || img.src).split('?')[0];

    if (store[key]) { paint(tile, store[key]); tile.dataset.rsTinted = '1'; return; }

    var go = function () {
      var pair;
      try { pair = sample(img); } catch (e) { return; }   // tainted canvas / CORS
      if (!pair) return;
      store[key] = pair; save();
      paint(tile, pair);
      tile.dataset.rsTinted = '1';
    };

    if (img.complete && img.naturalWidth) go();
    else img.addEventListener('load', go, { once: true });
  }

  function init() {
    var tiles = document.querySelectorAll('[data-rs-tint]');
    if (!tiles.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
        });
      }, { rootMargin: '300px' });
      tiles.forEach(function (t) { io.observe(t); });
    } else {
      tiles.forEach(run);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
